<template>
  <v-card class="rounded-lg white">
    <template v-if="isManager">
      <v-card-title class="secondary--text mb-5">{{ title }}</v-card-title>
      <v-card-text>
        <m-datatable
          :headers="headers"
          :apiUrl="url"
          :filters.sync="filters"
          :show-select="false"
          ref="datatable"
        >
          <template v-slot:item.created_at="{ item }">
            {{ item.created_at }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon small @click="openDetailDialog(item)">
              <v-icon small>fa-eye</v-icon>
            </v-btn>
          </template>
        </m-datatable>
      </v-card-text>

      <v-dialog v-model="detailDialog" max-width="700">
        <v-card class="rounded-lg pa-4" v-if="item">
          <v-card-title class="secondary--text">
            {{ modelTitle(item.model) }} #{{ item.object_id }} — {{ actionTitle(item.action) }}
          </v-card-title>
          <v-card-subtitle>
            {{ item.user_display || "بدون کاربر (سیستمی)" }} —
            {{ item.created_at }}
          </v-card-subtitle>
          <v-card-text>
            <v-simple-table dense>
              <thead>
                <tr>
                  <th>فیلد</th>
                  <th>قبل</th>
                  <th>بعد</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(diff, field) in item.changes" :key="field">
                  <td class="font-weight-bold">{{ field }}</td>
                  <td class="grey--text">{{ diff.old }}</td>
                  <td>{{ diff.new }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="detailDialog = false">بستن</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-card>
</template>

<script>
const MODEL_TITLES = {
  user: "کاربر",
  categorization: "دسته‌بندی",
  avail: "امکانات",
  feature: "ویژگی",
  shoporder: "سفارش",
  currency: "ارز",
};

export default {
  name: "AuditLogList",
  data() {
    return {
      filters: {},
      detailDialog: false,
      item: null,
    };
  },
  computed: {
    isManager() {
      return !!(this.user && (this.user.user_type === "ma" || this.user.is_superuser));
    },
    title() {
      return this.setDocumentTitle("تاریخچه تغییرات");
    },
    url() {
      return "audit-log/";
    },
    headers() {
      return [
        {
          text: "نوع",
          value: "model",
          items: Object.entries(MODEL_TITLES).map(([value, text]) => ({ text, value })),
        },
        { text: "شناسه رکورد", value: "object_id" },
        {
          text: "عملیات",
          value: "action",
          items: [
            { text: "ایجاد", value: "create" },
            { text: "ویرایش", value: "update" },
          ],
        },
        { text: "کاربر", value: "user_display", sortable: false },
        { text: "تاریخ", value: "created_at" },
        { text: "جزئیات", value: "actions", sortable: false, align: "center" },
      ];
    },
  },
  methods: {
    modelTitle(model) {
      return MODEL_TITLES[model] || model;
    },
    actionTitle(action) {
      return action === "create" ? "ایجاد" : "ویرایش";
    },
    openDetailDialog(item) {
      this.item = item;
      this.detailDialog = true;
    },
  },
};
</script>
